const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://api.jhytechs.com/api",
  IS_DEMO_MODE: process.env.REACT_APP_IS_DEMO_MODE === "true" || false,
};

export default config;
